import React, { useState, useRef } from 'react';
import data from '../../../data/services.json';

function Services() {
  const [selectedService, setSelectedService] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const itemsContainerRef = useRef(null); // Reference to container holding .item divs

  const handleServiceClick = (item) => {
    setSelectedService(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedService(null);
  };

 

  return (
    <div className="sec-box services section-padding bord-thin-bottom" id="services" ref={itemsContainerRef}>
      <div className="sec-head mb-80 wow fadeInUp">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <h6 className="sub-title opacity-7 mb-15">Our Services</h6>
            <h3>
              Turn Information{' '}
              <span className="main-color">Into Actionable</span> Insights
            </h3>
          </div>
        </div>
      </div>
      <div className="row">
        {data.map((item, index) => (
          <div key={index} className="col-md-6">
            <div
              className="item mb-40 wow fadeIn"
              data-wow-delay=".2s"
              onClick={() => handleServiceClick(item)}
              style={{ cursor: 'pointer' }}
            >
              <span className="icon-img-70 mb-30 opacity-7">
                <img src={item.icon} alt={item.title} />
              </span>
              <h6 className="text-u ls1 mb-15">{item.title}</h6>
              <p>{item.description}</p>
              <p className='mt-30'><strong>Click to Read More...</strong></p>
              <div className="bord-color"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && selectedService && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className='modal-header'>
            <span className="close-btn" onClick={closeModal}>
              &times;
            </span>
            <h2>{selectedService.title}</h2>
            </div>
            <div className="modal-content-main"
              dangerouslySetInnerHTML={{ __html: selectedService.descriptionmain }}
            ></div>
          </div>
        </div>
      )}

      {/* Modal Styles */}
      <style jsx>{`
              .modal-overlay {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.7);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1000;
              }
              .modal-content {
              background: #232323;
              padding: 0;
              border-radius: 10px;
              width: 80%;
              max-width: fit-content;
              text-align: left;
              position: relative;
              height: 80%;
              border: 1px solid #ffffff;
              overflow: hidden;
              }
              .modal-content ul li {
              list-style: disc;
              }
              .modal-content h2 {
              margin-bottom: 0;
              padding-right: 40px;
              }
              .modal-content h5 {
              margin:20px auto;
              }
              .modal-content img {
              max-width: -webkit-fill-available;
              margin: 25px;
              }
              .modal-header {
              display: flex;
              flex-shrink: 0;
              align-items: center;
              justify-content: space-between;
              padding: 20px;
              border-bottom: 1px solid #dee2e6;
              border-top-left-radius: calc(.3rem - 1px);
              border-top-right-radius: calc(.3rem - 1px);
              margin-bottom: 15px;
              position: sticky;
              top: 0;
              background: #232323;
              }
.modal-content-main{
padding:20px;
overflow-y: auto;}
              body:has(.modal-content){
              overflow-y: hidden;
              }
              .close-btn {
              position: absolute;
              top: 10px;
              right: 10px;
              font-size: 34px;
              cursor: pointer;
              width: 34px;
              }
      `}</style>
    </div>
  );
}

export default Services;
